import { ApiKy } from './index'
import { HttpStatus } from '~/constants/http'
import {
  ActiveNotificationBanner,
  GetNotificationBannerHistoryParams,
  GetNotificationBannerHistoryResponse,
  NotificationBanner,
  OpenNotificationBannerPayload,
  UpdateNotificationBannerPayload,
} from '~/types/notification-banner'

export default class Api extends ApiKy {
  async getActive() {
    const response = await this.ky.get(`${this.url}/active`)
    if (response.status === HttpStatus.NO_CONTENT) return null
    return response.json<ActiveNotificationBanner>()
  }

  getHistory(params: GetNotificationBannerHistoryParams) {
    return this.ky
      .get(`${this.url}/history`, { searchParams: params })
      ?.json<GetNotificationBannerHistoryResponse>()
  }

  open(payload: OpenNotificationBannerPayload) {
    return this.ky
      .post(`${this.url}/open`, { json: payload })
      ?.json<NotificationBanner>()
  }

  close() {
    return this.ky.post(`${this.url}/close`)
  }

  update(payload: UpdateNotificationBannerPayload) {
    return this.ky
      .patch(`${this.url}`, { json: payload })
      ?.json<NotificationBanner>()
  }
}
